//
import { MainLayout } from '@/components/reusable_components/next'
import { IndexView } from '@/views'

// POS Routes
import PosSaleRoutes from './POS/PosSale'

// Purchase Routes
import ProviderRoutes from './Purchase/PchProvider'
import PurchaseOrderRoutes from './Purchase/PchPurchaseOrder'

// Warehouse Routes
import DispatchRequestRoutes from './Warehouse/WhDispatchRequest'
import DispatchRequestBatchRoutes from './Warehouse/WhDispatchRequestBatch'
import InventoryRoutes from './Warehouse/WhInventory'
import KardexRoutes from './Warehouse/WhKardex'
import OrdererRoutes from './Warehouse/WhOrderer'
import ProductRoutes from './Warehouse/WhProduct'
import RepackingHistoricRoutes from './Warehouse/WhRepackingHistoric'
import StockAdjustRoutes from './Warehouse/WhStockAdjust'
import StockMovementRoutes from './Warehouse/WhStockMovement'
import TransferBetweenWarehouseRoutes from './Warehouse/WhTransferBetweenWarehouse'
import WarehouseRoutes from './Warehouse/WhWarehouse'

//
export default [
    {
        path: '/',
        //name: "Index",
        component: MainLayout,
        children: [
            // Default view
            {
                path: '',
                name: 'index',
                component: IndexView,
            },

            // POS Routes
            PosSaleRoutes,

            // Purchase Routes
            ProviderRoutes,
            PurchaseOrderRoutes,

            // Warehouse Routes
            DispatchRequestRoutes,
            DispatchRequestBatchRoutes,
            InventoryRoutes,
            KardexRoutes,
            OrdererRoutes,
            ProductRoutes,
            RepackingHistoricRoutes,
            StockAdjustRoutes,
            StockMovementRoutes,
            TransferBetweenWarehouseRoutes,
            WarehouseRoutes,
        ],
        props: {
            breadcrumbsProps: {
                indexText: 'Inventario',
            },
        },
    },
]
